import { render, staticRenderFns } from "./ResourceCancelModal.vue?vue&type=template&id=0c5ffad2&scoped=true&"
import script from "./ResourceCancelModal.vue?vue&type=script&lang=js&"
export * from "./ResourceCancelModal.vue?vue&type=script&lang=js&"
import style0 from "./ResourceCancelModal.vue?vue&type=style&index=0&id=0c5ffad2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5ffad2",
  null
  
)

export default component.exports